export enum PersonalOfferCategoryType {
  addons = 'Dodaci',
  prepaid2Postpaid = 'Prepaid2Postpaid',
  topup = 'Dopuna',
  contractRenewal = 'Reugovor',
  recommendedTariff = 'Preporučene tarife',
}
